var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.656,
    height: 19.57,
    viewBox: "0 0 15.656 19.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1238",
    "data-name": "Group 1238",
    transform: "translate(2307 -912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "description_FILL0_wght400_GRAD0_opsz48",
    d: "M9.468,23.57A1.5,1.5,0,0,1,8,22.1V5.468A1.408,1.408,0,0,1,8.44,4.44,1.408,1.408,0,0,1,9.468,4H18.3l5.357,5.357V22.1a1.5,1.5,0,0,1-1.468,1.468Zm8.1-13.552-8.1-4.55Zm-8.1-4.55v0Z",
    transform: "translate(-2315 908)",
    fill: "#8a8fab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "picture_as_pdf_FILL0_wght400_GRAD0_opsz48",
    d: "M16.55,21.215h.905v-2.03h1.174a.878.878,0,0,0,.905-.905V17.105a.878.878,0,0,0-.905-.905H16.55Zm.905-2.935V17.105h1.174v1.174Zm3.156,2.935h2.055a.89.89,0,0,0,.636-.257.858.858,0,0,0,.269-.648v-3.2a.858.858,0,0,0-.269-.648.89.89,0,0,0-.636-.257H20.611Zm.905-.905v-3.2h1.15v3.2Zm3.253.905h.905v-2.03H26.9v-.905H25.674V17.105H26.9V16.2H24.769Z",
    transform: "translate(-2320.896 904.704)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfOut);
export default __webpack_public_path__ + "static/media/pdfOut.de14985bad6851adbd1964aef782902b.svg";
export { ForwardRef as ReactComponent };